import React from 'react';
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";

import Printer from './images/group-2.jpg';
import Printer2x from './images/group-2@2x.jpg';
import Printer3x from './images/group-2@3x.jpg';

let cx = classNames.bind(styles);

const Header = (props) => (
    <div className={styles.header}>
        <Row type="flex" justify="center">
            <Col md={{offset: 1, span: 11}} lg={7}>
                <div className={styles.inkLevelTxt}>Your printer ink levels are low!</div>
                <div className={styles.printerType}>HP OfficeJet Pro 6800 Series</div>
            </Col>
            <Col span={1} className={styles.printerPipeCol}>
                <div className={styles.printerPipe}></div>
            </Col>
            <Col md={11} lg={6} className={styles.printerInkCol}>
                <img src={Printer} alt="Your Printer"
                     srcSet={`${Printer2x} 2x,
                             ${Printer3x} 3x`}/>
                {/* <span className={cx(styles.icon, styles.warning)}></span> */}
            </Col>
        </Row>
    </div>
);

export default Header;
